import { datadogRum } from '@datadog/browser-rum';

import Axios, { type AxiosError, type AxiosRequestConfig } from 'axios';

import { apis } from '@apis/apis';
import { getCookie, removeCookie } from '@utils/cookies';
import { IError } from '@type/db';

export const AXIOS_INSTANCE = Axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	withCredentials: true,
});

AXIOS_INSTANCE.interceptors.request.use(function (config) {
	const token = getCookie('imms_access_token');
	const workspaceCode = getCookie('imms_workspace_code');
	if (!token || !config.headers) return config;
	config.headers.Authorization = `Bearer ${token}`;
	if (workspaceCode) config.headers['Ft-Workspace'] = workspaceCode;
	return config;
});

AXIOS_INSTANCE.interceptors.response.use(
	function (response) {
		// 정상 응답 처리
		return response;
	},
	function (error: IError) {
		// 데이터독 에러 트레킹을 위해 해당 메소드 추가
		datadogRum.addError(error.response.data);

		if (error.response.data.resultCode === 'token_not_valid') {
			removeCookie('imms_access_token', { path: '/' });
			removeCookie('imms_workspace_code', { path: '/' });
			apis.logout();
		}
		return Promise.reject(error.response.data);
	},
);

export const customInstance = <T>(
	config: AxiosRequestConfig,
	options?: AxiosRequestConfig,
): Promise<T> => {
	const source = Axios.CancelToken.source();

	const promise = AXIOS_INSTANCE({
		...config,
		...options,
		cancelToken: source.token,
	}).then(({ data }) => data.result);

	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-expect-error
	promise.cancel = () => {
		source.cancel('Query was cancelled');
	};

	return promise;
};

// In some case with react-query and swr you want to be able to override the return error type so you can also do it here like this
export type ErrorType<Error> = AxiosError<Error>;

export type BodyType<BodyData> = BodyData;
